module.exports = __webpack_public_path__ + "assets/media/install-video-thumbnail.83c752d4.jpg";